<h1 matDialogTitle>Add Misc. Charge</h1>

<mat-dialog-content>
  <div>
    <div>
      <form [formGroup]="form">
        <form class="dynamic-form" [formGroup]="form" style="width: 100%">
          <div fxLayout="row wrap" fxLayoutAlign="start start" fxFlexFill fxLayoutGap="16px grid">

            <mat-form-field fxFlex="100" width="100%">
              <mat-label>Misc. Service Charge</mat-label>
              <mat-select name="charge" formControlName="chargeCode" (selectionChange)="chargeCodeSelected($event)">
                <mat-option *ngFor="let serviceCharge of serviceChargeConfig" [value]="serviceCharge.chargeCode">
                  {{serviceCharge.chargeDescription}}
                </mat-option>
              </mat-select>
            </mat-form-field>


            <ng-container *ngIf="selectedCharge" >
              <ng-container *ngIf="showQtyInput && selectedCharge.defaultTypeCode && selectedCharge.defaultTypeCode.length > 0; else unitInputs">

                <mat-form-field fxFlex="100" width="100%">
                  <mat-label>{{selectedCharge.userPrompt || 'Please enter service charge value'}}</mat-label>
                  <input matInput style="text-align: right;" type="number" formControlName="defaultValue">
                  <mat-error *ngIf="form.controls['defaultValue'].invalid">The minimum quantity is {{selectedCharge.minimumQuantity}}</mat-error>
                </mat-form-field>

              </ng-container>
              <ng-template #unitInputs>
                <mat-form-field *ngIf="selectedCharge.calculationType === 'U'" fxFlex="100" width="100%" >
                  <mat-label>{{selectedCharge.userPrompt || 'Please enter number of units'}}</mat-label>
                  <input matInput style="text-align: right;" type="number" formControlName="qty">
                  <mat-error *ngIf="form.controls['qty'].invalid">The minimum quantity is {{selectedCharge.minimumQuantity}}</mat-error>
                </mat-form-field>
              </ng-template>
            </ng-container>

          </div>
        </form>
      </form>
    </div>
  </div>
</mat-dialog-content>

<mat-dialog-actions>
  <button mat-button matDialogClose>Cancel</button>
  <button mat-button [disabled]="!form.valid" (click)="save()">Save</button>
</mat-dialog-actions>
